import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';

var NvMarkdownInline = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.elementWrapper, Element = _b === void 0 ? 'h2' : _b, props = __rest(_a, ["children", "className", "elementWrapper"]);
    var markdownOptions = __assign({ disableParsingRawHTML: false, forceInline: true, forceWrapper: true, wrapper: Element }, props);
    /**
     * Replace words between ^carets^ with <sup>carets</sup>
     */
    var text = React.useMemo(function () {
        if (!children)
            return '';
        return children.replace(/\^(.*?)\^/g, '<sup>$1</sup>');
    }, [children]);
    return (React.createElement(Markdown, __assign({}, props, { className: classNames(className, 'nv-markdown', 'nv-markdown-inline'), options: markdownOptions }), text));
};

export { NvMarkdownInline as default };
//# sourceMappingURL=NvMarkdownInline.esm.js.map
